<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Departments</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Departments"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox
                            label="Active Only"
                            v-model="activeOnly"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="departments"
                            :loading="loading"
                            :search="search"
                            hide-actions
                            must-sort
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.Name}}</td>
                                    <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
export default {
    components: {
        
    },
    props: [
        
    ],
    data() {
        return {
            search: "",
            activeOnly: true,
            headers: [
                {
                    text: "Name",
                    value: "Name"
                },
                {
                    text: "Active",
                    value: "Active"
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.departmentStore.loading;
        },
        loadError() {
            return this.$store.state.departmentStore.loadError;
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active || !this.activeOnly);
        }
    },
    methods: {
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        }
    },
    created() {
        this.loadDepartments();
    }
};
</script>

<style>

</style>
